import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { validarCoberturaEAD, validarFXC } from "../logic";

type Entity = models.ServiciosAdicionales;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    servicio: models.ServicioDocumentacion;
    tipo: "paquete" | "sobre";
    puedeModificarRecoleccion: boolean;
    asignarSeguroDefault?: boolean;
    esFolioGuiaPP: boolean;
    error?: kea.FieldError;
}

export function validarServiciosAdicionales(x: Entity, servicio: models.ServicioDocumentacion) {
    const rules: validation.Rules<Entity> = {
        IdRequerimientoAcuse: x => x.Acuse == models.TipoAcuse.Externo && x.IdRequerimientoAcuse == null ? "Requerido" : true,
        EntregaDomicilio: x => validarCoberturaEAD(servicio),
        FletePorCobrar: async x => await validarFXC(x, servicio),
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
class ServiciosAdicionalesView1 extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    esFolioGuiaPP = (props: Props) => props.esFolioGuiaPP;
    puedeModificarRecoleccion = (props: Props) => props.puedeModificarRecoleccion;
    asignarSeguroDefault = (props: Props) => props.asignarSeguroDefault;

    errors = createSelectorRx(this.value, x => validarServiciosAdicionales(x, this.props.servicio));
    getField = formfields(() => this.props, () => this.errors(this.props));


    onTipoAcuseChange = (x: models.TipoAcuse | null) => {
        const change: Partial<Entity> = x != models.TipoAcuse.Externo ? {
            Acuse: x,
            IdRequerimientoAcuse: undefined
        } : {
                Acuse: x
            };

        this.props.onChange({ ... this.props.value, ...change });
    }

    render() {
        const { value, tipo } = this.props;
        const getField = this.getField;
        const puedeModificarRecoleccion = this.puedeModificarRecoleccion(this.props);
        const asignarSeguroDefault = this.asignarSeguroDefault(this.props);

        const esFolioGuiaPP = this.esFolioGuiaPP(this.props);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const RequerimientoAcuse = getField(selectores.RequerimientoAcuse);

        return (
            <kea.Panel title="Servicios adicionales" iconClass={fa("plus-circle")} error={this.props.error} >
                {kea.autogrid(6, [
                    <Check field="EntregaDomicilio" label="Entrega a domicilio" />,
                    <Check field="RecoleccionDomicilio" label="Recolección a domicilio" readonly={!puedeModificarRecoleccion} />,
                    <Check field="FletePorCobrar" label="Flete por cobrar" readonly={esFolioGuiaPP} />,
                ])}
                {kea.autogrid(6, [
                    <selectores.TipoAcuse value={this.props.value.Acuse} onChange={this.onTipoAcuseChange} label="Tipo de acuse" />,
                    this.props.value.Acuse == models.TipoAcuse.Externo && <RequerimientoAcuse field="IdRequerimientoAcuse" label="Requerimiento de acuse externo" />,
                    tipo == "paquete" &&
                    <div>
                        {
                            (value.ValorDeclarado == 1000 && asignarSeguroDefault == true) &&
                            <div className="alert alert-info">
                                <span>
                                    <i className={fa("exclamation-circle")} />
                                    Valor declarado por default, preguntar al cliente si desea modificarlo
                            </span>
                            </div>
                        }
                        <Number field="ValorDeclarado" label="Valor declarado (seguro)" format="currency" />
                    </div>,
                    <Number field="ValorFactura" label="Valor factura" format="currency" />,
                    <Number field="ServicioEspecial" label="Servicio especial" format="currency" />

                ])}
            </kea.Panel>);
    }
}

export const ServiciosAdicionalesView = kea.defaultProps(ServiciosAdicionalesView1, { value: {} as Entity });


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/adicionales/view.tsx